import * as React from 'react';
import { IConfig } from '@cian/config/shared';

import {
  UXFB_CLIENT_EVENTS_CONFIG_KEY,
  UXFB_DEAL_TYPE,
  UXFB_EVENT_OPEN_ZHK_CARD,
  UXFB_PLATFORM,
} from '../../../constants/uxfb';
import { sendUXSEventWhenReady } from '../../../utils/uxs';

/**
 * Шлёт UXFB-событие `open_zhk_card` один раз при заходе на карточку ЖК (mount).
 * Никакого клиентского подсчёта заходов — правила частоты («повторный заход в течение 7 дней»)
 * настраиваются в админке UXFB.
 *
 * Конфиг приходит параметром, а не из useApplicationContext: хук вызывается в теле Application,
 * выше его же ApplicationContext.Provider.
 *
 * `dedupeKey` обязателен: ремаунт контейнера перезапускает эффект, дубль события засчитывается
 * бэкендом UXFB как лишний «заход», и кампании «на 2-й заход» выезжают уже на первом.
 */
export function useOpenZhkCardUxfbEvent(config: IConfig): void {
  React.useEffect(() => {
    if (config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) === false) {
      return;
    }

    sendUXSEventWhenReady(
      UXFB_EVENT_OPEN_ZHK_CARD,
      { platform: UXFB_PLATFORM, deal_type: UXFB_DEAL_TYPE },
      { dedupeKey: UXFB_EVENT_OPEN_ZHK_CARD },
    );
  }, [config]);
}
